/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelOrderItems64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelOrderItems64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.1"
            d="M12 15C12 13.3431 13.3431 12 15 12H49C50.6569 12 52 13.3431 52 15V49C52 50.6569 50.6569 52 49 52H15C13.3431 52 12 50.6569 12 49V15Z"
            fill="currentColor"
          />
          <g>
            <path
              d="M34 29C34.5522 29.0001 35 29.4478 35 30C35 30.5522 34.5522 30.9999 34 31C33.4477 31 33 30.5523 33 30C33 29.4477 33.4477 29 34 29Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M37 26C37.5522 26.0001 38 26.4478 38 27V32.293C38 32.5581 37.8945 32.8125 37.707 33L32.207 38.5C31.8165 38.8905 31.1835 38.8904 30.793 38.5L25.5 33.207C25.1095 32.8165 25.1095 32.1835 25.5 31.793L31 26.293C31.1875 26.1055 31.4418 26 31.707 26H37ZM26.207 32.5L31.5 37.793L37 32.293V27H31.707L26.207 32.5Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M49 12C50.6568 12 52 13.3432 52 15V49C52 50.6568 50.6568 52 49 52H15C13.3431 52 12 50.6569 12 49V15C12 13.3431 13.3431 12 15 12H49ZM15 13C13.8954 13 13 13.8954 13 15V49C13 50.1046 13.8954 51 15 51H49C50.1045 51 51 50.1045 51 49V15C51 13.8955 50.1045 13 49 13H15Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelOrderItems64Icon.tags = [
  'add',
  'order',
  'cart',
  'shopping',
  'plus',
  'tag',
];

AddPanelOrderItems64Icon.category = '64x64 (Add panel)';

AddPanelOrderItems64Icon.iconSize = 64;
